exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.photo-row-thumbnail[data-v-8c8f14d6] {\n  width: 40px;\n  height: 40px;\n  border: solid 1px #dbdbdb;\n  background-color: #FFFFFF;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: 6px;\n  display: inline-block;\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/components/AddLogo.vue"],"names":[],"mappings":";AACA;EACE,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;CACvB","file":"AddLogo.vue","sourcesContent":["\n.photo-row-thumbnail[data-v-8c8f14d6] {\n  width: 40px;\n  height: 40px;\n  border: solid 1px #dbdbdb;\n  background-color: #FFFFFF;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-right: 6px;\n  display: inline-block;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8c8f14d6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AddLogo.vue
// module id = wy/m
// module chunks = 4